@if(currentSection === 'summary'){
  <div class="py-200-rem px-250-rem h-full" data-testid="summary">
    <div class="flex flex-col space-y-050-rem">
      <h1 class="text-headline-md-weight-medium text-action-fg-secondary">Summary</h1>
      <div class="text-container-fg-muted text-label-md-weight-regular max-w-2xl">
        Please review the summary of the provided information and go back to edit if needed. <br />You
        can then proceed and create the firmware package.
      </div>
    </div>
    <div
      class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default w-4xl max-w-4xl flex flex-col">
      <h1 class="text-headline-sm-weight-medium text-container-fg-default">File upload</h1>

      <div>
        <div class="flex items-center justify-between mt-075-rem">
          <div class="flex items-center gap-075-rem">
            <div>
              <img src="/svgs/file-icon.svg" alt="file" />
            </div>
            <div class="flex flex-col">
              <span class="truncate block max-w-50"> {{ allFormData().fileUpload.fileName }}</span>
              <span class="text-gray-500"
                >{{ allFormData().fileUpload.fileSize | number }} bytes</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default w-4xl max-w-4xl gap-3 flex flex-col">
        <h1 class="text-headline-sm-weight-medium text-container-fg-default">Manifest information</h1>
        <div class="-mr-100-rem">
          <div [innerHTML]="extractedXmlContent()" data-testid="xml-content"></div>
        </div>
      </div>

      <div
        class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default w-4xl max-w-4xl gap-6 flex flex-col">
        <h1 class="text-headline-sm-weight-medium text-container-fg-default">Package metadata</h1>
        <div class="space-y-6">
          <div>
            <h3 class="text-label-lg-weight-medium text-container-fg-default">Package name</h3>
            <p class="text-body-lg-weight-regular text-container-fg-default">
              {{ allFormData().packageMetadata.packageName }}
            </p>
          </div>

          <div>
            <h3 class="text-label-lg-weight-medium text-container-fg-default">Update class</h3>
            <mat-radio-group
              aria-label="update classification"
              class="grid pt-025-rem"
              [disabled]="true"
              [value]="allFormData().packageMetadata.classification">
              <mat-radio-button value="Critical update">Critical update</mat-radio-button>
              <mat-radio-button value="Major update">Major update</mat-radio-button>
              <mat-radio-button value="Minor update">Minor update</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <div
        class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default w-4xl max-w-4xl flex flex-col">
        <h1 class="text-headline-sm-weight-medium text-container-fg-default">Device compatibility</h1>

        <div class="flex flex-col gap-100-em mt-100-em justify-start">
          @for (versions of allFormData().deviceCompatibility.compatible_device_software_versions; track versions; let i = $index) {
            <div
              class="flex items-center gap-x-100-em"
              >
              <div class="text-body-md-weight-regular text-container-fg-muted">CP</div>
              <div>
                <p class="text-label-sm-weight-regular text-container-fg-muted">
                  Compatible device software versions
                </p>
                <p class="text-body-lg-weight-regular text-container-fg-default">{{versions.value}}</p>
              </div>
            </div>
          }
        </div>
      </div>

      <div
        class="py-150-rem px-150-rem my-150-rem rounded-050 bg-container-bg-default border border-container-border-default w-4xl max-w-4xl gap-6 flex flex-col">
        <h1 class="text-headline-sm-weight-medium text-container-fg-default text-[1.125rem]">
          Distribution
        </h1>

        <form class="space-y-100-rem">
          <p class="text-label-lg-weight-medium">Allowed to install by</p>
          <div class="opacity-45">
            <mat-button-toggle-group
              name="mat-button-toggle-group"
              aria-label="access"
              [disabled]="true"
              [value]="allFormData().distribution.access">
              <mat-button-toggle value="Update by CPO">Update by CPO</mat-button-toggle>
              <mat-button-toggle value="Update by CPO & end-user">Update by CPO & user</mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <div>
            <p class="text-label-lg-weight-medium">Installable via</p>

            @for(appDetails of allFormData().distribution.supportedCompanionApps; track
              appDetails.name){
              <div class="grid grid-cols-3 space-y-150-rem">
                <mat-checkbox [disabled]="true" [checked]="appDetails.name.length > 0">
                  {{ appDetails.name }}
                </mat-checkbox>
                <div>
                  <p class="text-label-sm-weight-regular text-container-fg-muted">iOS minimum version</p>
                  <p class="text-body-lg-weight-regular text-[1rem] text-container-fg-default">
                    {{ appDetails.appleMinimumVersion }}
                  </p>
                </div>

                <div>
                  <p class="text-label-sm-weight-regular text-container-fg-muted">
                    Android minimum version
                  </p>
                  <p class="text-body-lg-weight-regular text-[1rem] text-container-fg-default">
                    {{ appDetails.androidMinimumVersion }}
                  </p>
                </div>
              </div>
            }
          </div>
        </form>
      </div>

      <div
        class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default w-4xl max-w-4xl gap-6 flex flex-col">
        <h1 class="text-headline-sm-weight-medium text-container-fg-default">Release notes</h1>
        <h3 class="text-label-lg-weight-medium text-container-fg-default">JSON input</h3>
        <p class="release-notes-content text-container-fg-disabled whitespace-pre-wrap">
          {{allFormData().releaseNotes.release_notes }}
        </p>
      </div>
    </div>
  }
